<template>
  <v-app>
    <toolbar/>
    <v-content style="font-family: 'Poppins', sans-serif;">
      <router-view/> 
    </v-content>
    <div class="text-center subtitle-1 white--text orange pa-4">
      <p class="text-center pt-2 pb-2" style="color:#333;font-size:14px;">
                <strong>(c) 2021 Pipe Me Industry, LLC.</strong> <br>
PIPE ME IN and the PIPE ME IN logo are trademarks of its respective owner. <br>
All sales are final!
            </p>
    </div>
  </v-app>
</template>

<style>
@font-face {
  font-family: "Optima";
  src: url("http://esteticavillalba.ml/fuentes/optima.otf");
}
*::selection {
    background: #f79c14;
    color: white;
  }
  .v-btn {
    text-transform: none;
  }
</style>

<script>
import { mapState } from "vuex";
import toolbar from './components/toolbar'
export default {
  name: 'App',
  data: () => ({
    //
  }),
  components:{
    toolbar
  },
  computed: {
    ...mapState(['carga'])
  },
};
</script>
